import React from 'react';
import PropTypes from 'prop-types';
import oneAppModuleWrapper from '@americanexpress/one-app/module-wrapper';
import { IntlProvider } from 'react-intl';
import {
// addLogToReport,
loadLanguagePack, updateLocale } from '@americanexpress/one-app/ducks';
import { ProgressCircular } from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';
import childRoutes from './childRoutes';
import combineReducers from './redux/ducks';
import { getLocaleFromCountry } from './utils/ModuleMap';
import { getIsLoading } from './redux/selectors';
import { SET_IS_LOADING } from './redux/types';
const AxpDigitalIdentityUnsubscribe = ({
  languageData,
  locale,
  // location,
  children,
  moduleLoadStatus
}) => {
  const isLoading = useSelector(getIsLoading);
  if (Object.entries(languageData).length === 0 && moduleLoadStatus === 'loading' && isLoading) {
    return /*#__PURE__*/React.createElement(ProgressCircular, null);
  }
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale,
    messages: languageData
  }, /*#__PURE__*/React.createElement("link", {
    rel: "stylesheet",
    href: "https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.15.0/stylesheets/dls-core.min.css"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    type: "image/png",
    href: "https://www.americanexpress.com/favicon.ico"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0",
    charSet: "utf-8"
  }), /*#__PURE__*/React.createElement("title", null, "Unsubscribe"), children);
};
export const TestableAxpDigitalIdentityUnsubscribe = AxpDigitalIdentityUnsubscribe;
// Read about childRoutes:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/Routing.md#childroutes
AxpDigitalIdentityUnsubscribe.childRoutes = childRoutes;

// Read about appConfig:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/App-Configuration.md
/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line n/global-require -- require needs to be inside browser check
  AxpDigitalIdentityUnsubscribe.appConfig = require('./appConfig').default;
}

// const dispatchDebugLog = (dispatch, {
//   level = 'info',
//   eventName,
//   payload,
// }) => dispatch(addLogToReport(level, eventName, payload));

export const loadModuleData = async ({
  store,
  // fetchClient,
  ownProps = {}
}) => {
  if (global.BROWSER) return;
  const {
    dispatch
  } = store;
  const {
    location = {}
  } = ownProps;
  const contextCountry = (location.pathname || '').split('/')[2];
  const mappedLocale = getLocaleFromCountry(contextCountry);
  // const env = (process.env.ONE_CONFIG_ENV || 'e0').toLowerCase();
  dispatch({
    type: SET_IS_LOADING,
    payload: true
  });
  try {
    await dispatch(updateLocale(mappedLocale));
    await dispatch(loadLanguagePack('axp-digital-identity-unsubscribe', {
      fallbackLocale: mappedLocale
    }));
  } finally {
    dispatch({
      type: SET_IS_LOADING,
      payload: false
    });
  }

  //! enable it when we have the global header and footer modules are migrated to holocron v7
  // await dispatch(composeModules([{ name: 'axp-global-header' }, { name: 'axp-footer' }]));
};
AxpDigitalIdentityUnsubscribe.holocron = {
  name: 'axp-digital-identity-unsubscribe',
  loadModuleData,
  reducer: combineReducers
};
export default oneAppModuleWrapper('axp-digital-identity-unsubscribe')(AxpDigitalIdentityUnsubscribe);